"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSymbol = exports.isString = exports.isSet = exports.isObject = exports.isNumber = exports.isNone = exports.isMap = exports.isFunction = exports.isBoolean = exports.isBlob = exports.isArray = void 0;
/**
 * 获取值的类型
 * @param value - 要获取类型的值
 * @returns 值的类型
 */
const getDefineType = value => {
  return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
};

/**
 * 判断值是否为字符串类型
 * @param value - 要判断的值
 * @returns 值是否为字符串类型
 */
const isString = value => {
  return getDefineType(value) === 'string';
};

/**
 * 判断值是否为数字类型
 * @param value - 要判断的值
 * @param noScientificNotation - 不允许科学计数法
 * @returns 值是否为数字类型
 */
exports.isString = isString;
const isNumber = (value, noScientificNotation) => {
  if (getDefineType(value) !== 'number') {
    return false;
  }
  if (isNaN(value) || value === Infinity || value === -Infinity) {
    return false;
  }
  if (noScientificNotation) {
    return !/e/i.test(value.toString());
  }
  return true;
};

/**
 * 判断值是否为布尔类型
 * @param value - 要判断的值
 * @returns 值是否为布尔类型
 */
exports.isNumber = isNumber;
const isBoolean = value => {
  return getDefineType(value) === 'boolean';
};

/**
 * 判断值是否为符号类型
 * @param value - 要判断的值
 * @returns 值是否为符号类型
 */
exports.isBoolean = isBoolean;
const isSymbol = value => {
  return getDefineType(value) === 'symbol';
};

/**
 * 判断值是否为对象类型
 * @param value - 要判断的值
 * @returns 值是否为对象类型
 */
exports.isSymbol = isSymbol;
const isObject = value => {
  return getDefineType(value) === 'object';
};

/**
 * 判断值是否为函数类型
 * @param value - 要判断的值
 * @returns 值是否为函数类型
 */
exports.isObject = isObject;
const isFunction = value => {
  return getDefineType(value) === 'function';
};

/**
 * 判断值是否为数组类型
 * @param value - 要判断的值
 * @returns 值是否为数组类型
 */
exports.isFunction = isFunction;
const isArray = value => {
  return getDefineType(value) === 'array';
};

/**
 * 判断值是否为Map类型
 * @param value - 要判断的值
 * @returns 值是否为Map类型
 */
exports.isArray = isArray;
const isMap = value => {
  return getDefineType(value) === 'map';
};

/**
 * 判断值是否为Set类型
 * @param value - 要判断的值
 * @returns 值是否为Set类型
 */
exports.isMap = isMap;
const isSet = value => {
  return getDefineType(value) === 'set';
};

/**
 * 判断值是否为Blob类型
 * @param value - 要判断的值
 * @returns 值是否为Blob类型
 */
exports.isSet = isSet;
const isBlob = value => {
  return getDefineType(value) === 'blob';
};

/**
 * 判断值是否为null、undefined、false、空字符串或NaN
 * @param value - 要判断的值
 * @returns 值是否为null、undefined、false、空字符串或NaN
 */
exports.isBlob = isBlob;
const isNone = value => {
  const type = getDefineType(value);
  return type === 'null' || type === 'undefined' || type === 'boolean' && value === false || type === 'string' && value === '' || type === 'number' && isNaN(value);
};
exports.isNone = isNone;